import React, { useContext } from "react";
import { Icon } from "rsuite";
import { HomeWrapper } from "./Home.styled";
import ImagesContainer from "../Components/Images/ImagesContainer";
import UploadModal from "../Components/PreviewModal";
import { useDate, useImageUploads, useSearchBar } from "../custom-hooks";
import { ImagesContext } from "../context/images.context";
import MainPageLayout from "../Components/MainPageLayout";

const FileInputTypes = ".png , .jpg , .jpeg";

function Home() {
  const {
    img,
    preview,
    description,
    percentage,
    setPercentage,
    selectedImage,
    setSelectedImage,
    isOpen,
    close,
    onFileInputChange,
    onDescriptionChange,
    setDescription,
    open,
  } = useImageUploads();
  const { images, isLoading } = useContext(ImagesContext);
  const { search, imgs, setimgs, handleSearchChange } = useSearchBar({
    images,
    isLoading,
  });
  const { fromDateValue, toDateValue, handleDateChange, resetDate } = useDate({
    images,
    setimgs,
  });

  return (
    <>
      <MainPageLayout>
        <HomeWrapper>
          <h3 className="head">Gallery</h3>

          <label htmlFor="FileUpload">
            <Icon icon="plus-circle" size="3x" />
            <input
              id="FileUpload"
              type="file"
              accept={FileInputTypes}
              onChange={onFileInputChange}
            />
          </label>
          <div className="searchContainer">
            <input
              type="text"
              placeholder="search images here"
              id="searchBar"
              value={search}
              onChange={(e) => handleSearchChange(e)}
            />
            <Icon icon="search" size="2x" />
          </div>

          <div className="dateFilterContainer">
            <div className="filters">
              <label htmlFor="">
                From :
                <input
                  type="date"
                  name="fromDate"
                  id="fromDate"
                  value={new Date(fromDateValue).toLocaleDateString("en-ca")}
                  onChange={handleDateChange}
                  max={new Date(toDateValue).toLocaleDateString("en-ca")}
                />
                <span class="validity"></span>
              </label>
              <label htmlFor="">
                To :
                <input
                  type="date"
                  name="toDate"
                  id="toDate"
                  value={new Date(toDateValue).toLocaleDateString("en-ca")}
                  min={new Date(fromDateValue).toLocaleDateString("en-ca")}
                  onChange={handleDateChange}
                  max={new Date().toLocaleDateString("en-ca")}
                />
                <span class="validity"></span>
              </label>
              <button className="resetDateBtn" onClick={resetDate}>
                Reset
              </button>
            </div>
          </div>
          <UploadModal
            img={img}
            preview={preview}
            setDescription={setDescription}
            description={description}
            onDescriptionChange={onDescriptionChange}
            percentage={percentage}
            setPercentage={setPercentage}
            isOpen={isOpen}
            close={close}
            open={open}
            isAlbum={false}
            albumId={null}
          />
          <ImagesContainer
            setSelectedImage={setSelectedImage}
            selectedImage={selectedImage}
            images={imgs}
            isLoading={isLoading}
            isAlbum={false}
            albumId={null}
          />
        </HomeWrapper>
      </MainPageLayout>
    </>
  );
}

export default Home;
